import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import { ISegmentationBlockHistoryResponse } from "../../@types/segmentationBlocks";

export interface SegmentationBlocksHistoryRequest {
  page: number;
  page_size?: number;
}

// GET /segment-assignments/change-log/?feature_type=EWA_BLOCKING
export const SegmentationBlocksHistoryApiService = async (
  request: SegmentationBlocksHistoryRequest
): Promise<ISegmentationBlockHistoryResponse> => {
  const url = "/segment-assignments/change-log/";
  const { data } = await axios.get(url, {
    params: {
      feature_type: "EWA_BLOCKING",
      page: request.page,
      page_size: request.page_size,
    },
  });
  return data;
};

const useSegmentationBlocksHistoryApiService = (
  request: SegmentationBlocksHistoryRequest
): UseQueryResult<ISegmentationBlockHistoryResponse, AxiosError> =>
  useQuery<ISegmentationBlockHistoryResponse, AxiosError>(
    ["SegmentationBlocksHistoryApiService", ...Object.values(request)],
    () => SegmentationBlocksHistoryApiService(request),
    { keepPreviousData: true }
  );

export default useSegmentationBlocksHistoryApiService;
